import React, { useEffect, useRef } from 'react';

/**
 * Razorpay Payment Button embed. Razorpay's script scans for the parent <form>
 * and injects the button into it. React can't render <script> inline, so we
 * append it to the form ref inside a useEffect.
 */
export function RazorpayPaymentButton({ buttonId, className }) {
  const formRef = useRef(null);

  useEffect(() => {
    const form = formRef.current;
    if (!form || !buttonId) return;

    // Clear any previous button so amount / button id changes re-render cleanly
    form.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/payment-button.js';
    script.async = true;
    script.setAttribute('data-payment_button_id', buttonId);
    form.appendChild(script);
  }, [buttonId]);

  return <form ref={formRef} className={className} data-testid="razorpay-payment-button-form" />;
}
